import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page report-page"
};
const _hoisted_2 = {
  class: "report"
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "w50"
};
const _hoisted_5 = {
  class: "w50"
};
import { onMounted, ref } from "vue";
import { closeToast, showLoadingToast } from "vant";
import { getAttendanceDateList, getAttendanceRecord } from "@/api/mini";
import Calendar from "@/components/calendar/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const today = ref("");
    const markers = ref([]);
    const dayList = ref([]);
    // 考勤地点展示：补卡 / 移动考勤 特殊处理，其余展示地点名称
    const signTypeText = item => {
      if (item.signType == 3) return "补卡";
      if (item.signType == 4) return "移动考勤";
      return item.addressName || "-";
    };
    // 获取某月有考勤记录的日期，并打上标记
    const getMonthDate = async (year, month) => {
      if (!year || !month) return;
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const res = await getAttendanceDateList({
          attendanceMonth: `${year}-${month}`
        });
        markers.value = ((res === null || res === void 0 ? void 0 : res.data) || []).map(date => {
          const [y, m, d] = date.split("-").map(Number);
          return {
            year: y,
            month: m,
            day: d,
            type: "corner",
            mark: "*",
            color: "red"
          };
        });
      } finally {
        closeToast();
      }
    };
    // 获取某一天的考勤记录
    const getDayDate = async (year, month, day) => {
      if (!year || !month || !day) return;
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const res = await getAttendanceRecord({
          attendanceDate: `${year}-${month}-${day}`
        });
        dayList.value = (res === null || res === void 0 ? void 0 : res.data) || [];
      } finally {
        closeToast();
      }
    };
    const handleMonthChange = payload => {
      void getMonthDate(payload.year, payload.month);
    };
    const handleDateChange = payload => {
      void getDayDate(payload.year, payload.month, payload.day);
    };
    onMounted(() => {
      const now = new Date();
      today.value = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
      void getMonthDate(now.getFullYear(), now.getMonth() + 1);
      void getDayDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
    });
    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Calendar, {
        markers: markers.value,
        value: today.value,
        onMonthChange: handleMonthChange,
        onDateChange: handleDateChange
      }, null, 8, ["markers", "value"]), _createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title"
      }, "考勤记录", -1)), dayList.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "label"
      }, [_createElementVNode("div", {
        class: "w50"
      }, "考勤地点"), _createElementVNode("div", {
        class: "w50"
      }, "考勤时间")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dayList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "value"
        }, [_createElementVNode("div", _hoisted_4, _toDisplayString(signTypeText(item)), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.signTime), 1)]);
      }), 128))], 64)) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "当天暂无考勤记录"
      }))])])]);
    };
  }
});